// Mise en grille « calendrier » (heatmap) : colonnes = semaines (lundi→dimanche),
// cellule = valeur du jour ou null (non saisi / hors plage).
import { dayKey } from './datetime';

export interface CalendarCell {
  date: string | null;
  value: number | null;
}

// Jour de la semaine avec lundi = 0 … dimanche = 6.
function mondayIndex(d: Date): number {
  return (d.getDay() + 6) % 7;
}

// Construit une matrice `semaines × 7` se terminant à `endDate`.
export function toCalendarMatrix(
  daily: readonly { date: string; value: number }[],
  endDate: Date,
  weeks = 13,
): CalendarCell[][] {
  const byDate = new Map(daily.map((d) => [dayKey(d.date), d.value]));

  const realEnd = new Date(endDate);
  realEnd.setHours(0, 0, 0, 0);

  // Aligne la fin au dimanche pour une dernière colonne complète.
  const alignedEnd = new Date(realEnd);
  alignedEnd.setDate(alignedEnd.getDate() + (6 - mondayIndex(realEnd)));

  // `weeks` colonnes exactes : le début tombe alors sur un lundi.
  const start = new Date(alignedEnd);
  start.setDate(start.getDate() - (weeks * 7 - 1));

  const columns: CalendarCell[][] = [];
  const cursor = new Date(start);
  for (let w = 0; w < weeks; w++) {
    const week: CalendarCell[] = [];
    for (let d = 0; d < 7; d++) {
      // Jours postérieurs à la fin réelle → padding.
      if (cursor > realEnd) {
        week.push({ date: null, value: null });
      } else {
        const key = dayKey(cursor);
        week.push({ date: key, value: byDate.has(key) ? byDate.get(key)! : null });
      }
      cursor.setDate(cursor.getDate() + 1);
    }
    columns.push(week);
  }
  return columns;
}
